import {inject, Injectable} from '@angular/core';
import {LoadImageParams} from "../types/telegram-page.types";
import {TelegramService} from "./telegram.service";

@Injectable({
  providedIn: 'root'
})
export class TelegramLoadFileService {
  private telegramService: TelegramService = inject(TelegramService);

  public async loadImage({ remoteId, accountId }: LoadImageParams): Promise<string> {
    if (!remoteId) { return ''; }

    return await this.telegramService.fetchImageUrl({
      remoteId: remoteId,
      accountId: accountId
    });
  }
}
